<div class="card">
    <div class="flex items-center gap-3 mb-6">
        <i class="pi pi-users text-xl text-sym-blue-600"></i>
        <div>
            <h1 class="text-lg font-bold text-sym-ink leading-tight">Cliente Ideal</h1>
            <p class="text-sm text-sym-gray-500">Identifica y analiza tus clientes más valiosos con inteligencia
                artificial</p>
        </div>
    </div>

    <div class="sym-card mb-8">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
            <div class="flex items-center gap-3 p-4 rounded-lg border border-sym-border bg-sym-surface">
                <i class="pi pi-bolt text-lg text-sym-blue-600"></i>
                <div>
                    <h3 class="text-sm font-semibold text-sym-ink">Análisis Predictivo</h3>
                    <p class="text-sm text-sym-gray-500">Previsión de comportamiento basada en datos históricos</p>
                </div>
            </div>

            <div class="flex items-center gap-3 p-4 rounded-lg border border-sym-border bg-sym-surface">
                <i class="pi pi-chart-bar text-lg text-sym-blue-600"></i>
                <div>
                    <h3 class="text-sm font-semibold text-sym-ink">Segmentación Avanzada</h3>
                    <p class="text-sm text-sym-gray-500">Identificación de patrones de comportamiento y valor</p>
                </div>
            </div>
        </div>

        <div class="max-w-3xl mx-auto text-center">
            <h2 class="text-sm font-semibold mb-2 text-sym-ink">Selecciona el modelo de análisis</h2>
            <p class="text-sm text-sym-gray-500 mb-4">
                Nuestros modelos predictivos analizan múltiples factores para identificar clientes ideales.
                Selecciona la opción que mejor se adapte a tu escenario actual.
            </p>

            <div class="flex flex-wrap items-center justify-center gap-3">
                <span class="sym-badge sym-badge--neutral">1 · Análisis Básico</span>
                <span class="sym-badge sym-badge--neutral">2 · Análisis Intermedio</span>
            </div>
        </div>
    </div>

    <!-- Tarjetas de modelos -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <!-- Modelo 1: Oportunidad -->
        <div class="sym-card sym-card--interactive relative flex flex-col">
            <div class="absolute top-6 right-6 flex gap-1.5">
                <span class="w-2.5 h-2.5 rounded-full bg-sym-blue-600"></span>
                <span class="w-2.5 h-2.5 rounded-full bg-sym-border"></span>
                <span class="w-2.5 h-2.5 rounded-full bg-sym-border"></span>
            </div>

            <div class="flex items-start gap-4 mb-6">
                <div
                    class="flex-shrink-0 w-14 h-14 rounded-xl bg-sym-blue-100 dark:bg-[color-mix(in_srgb,var(--sym-blue-600),transparent_80%)] flex items-center justify-center">
                    <i class="pi pi-arrow-up-right text-2xl text-sym-blue-700 dark:text-sym-blue-400"></i>
                </div>
                <div>
                    <span class="sym-label">Nivel 1</span>
                    <h3 class="text-base font-bold text-sym-ink">Oportunidad</h3>
                    <p class="text-sm text-sym-gray-500 mt-1">Análisis básico para identificación rápida</p>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div class="rounded-lg p-4 border border-sym-border bg-sym-surface">
                    <h4 class="font-semibold text-sym-ink mb-2 flex items-center gap-2">
                        <i class="pi pi-chart-bar text-sym-blue-600"></i>
                        Alcance del Modelo
                    </h4>
                    <p class="text-sm text-sym-gray-500">
                        Análisis básico utilizando indicadores financieros cuando no hay detalles de contrato
                        disponibles.
                    </p>
                </div>

                <div class="rounded-lg p-4 border border-sym-border bg-sym-surface">
                    <h4 class="font-semibold text-sym-ink mb-2 flex items-center gap-2">
                        <i class="pi pi-clock text-sym-blue-600"></i>
                        Tiempo de Procesamiento
                    </h4>
                    <p class="text-sm text-sym-gray-500">
                        Resultados rápidos, ideal para decisiones iniciales y exploración preliminar.
                    </p>
                </div>
            </div>

            <div class="rounded-lg p-4 border border-sym-border bg-sym-surface mb-6">
                <h4 class="font-semibold text-sym-ink mb-3">Características incluidas</h4>
                <ul class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Análisis financiero</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Recomendación inicial</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Riesgo financiero básico</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Alertas de oportunidad</span>
                    </li>
                </ul>
            </div>

            <p-button label="Seleccionar y comenzar" icon="pi pi-arrow-right" iconPos="right"
                (onClick)="navigateToModel('oportunidad')" styleClass="w-full mt-auto" />
        </div>

        <!-- Modelo 2: Nueva Oferta -->
        <div class="sym-card sym-card--interactive relative flex flex-col">
            <p-tag value="Recomendado" severity="success" styleClass="absolute -top-3 right-6" />

            <div class="absolute top-6 right-6 flex gap-1.5">
                <span class="w-2.5 h-2.5 rounded-full bg-sym-blue-600"></span>
                <span class="w-2.5 h-2.5 rounded-full bg-sym-blue-600"></span>
                <span class="w-2.5 h-2.5 rounded-full bg-sym-border"></span>
            </div>

            <div class="flex items-start gap-4 mb-6">
                <div
                    class="flex-shrink-0 w-14 h-14 rounded-xl bg-sym-blue-100 dark:bg-[color-mix(in_srgb,var(--sym-blue-600),transparent_80%)] flex items-center justify-center">
                    <i class="pi pi-file-edit text-2xl text-sym-blue-700 dark:text-sym-blue-400"></i>
                </div>
                <div>
                    <span class="sym-label">Nivel 2</span>
                    <h3 class="text-base font-bold text-sym-ink">Nueva Oferta</h3>
                    <p class="text-sm text-sym-gray-500 mt-1">Análisis completo para optimizar oportunidades</p>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div class="rounded-lg p-4 border border-sym-border bg-sym-surface">
                    <h4 class="font-semibold text-sym-ink mb-2 flex items-center gap-2">
                        <i class="pi pi-chart-bar text-sym-blue-600"></i>
                        Alcance del Modelo
                    </h4>
                    <p class="text-sm text-sym-gray-500">
                        Análisis intermedio que combina datos financieros y patrones de comportamiento del cliente
                        para una visión completa.
                    </p>
                </div>

                <div class="rounded-lg p-4 border border-sym-border bg-sym-surface">
                    <h4 class="font-semibold text-sym-ink mb-2 flex items-center gap-2">
                        <i class="pi pi-clock text-sym-blue-600"></i>
                        Tiempo de Procesamiento
                    </h4>
                    <p class="text-sm text-sym-gray-500">
                        Análisis detallado con resultados en minutos. Perfecto para planificación estratégica.
                    </p>
                </div>
            </div>

            <div class="rounded-lg p-4 border border-sym-border bg-sym-surface mb-6">
                <h4 class="font-semibold text-sym-ink mb-3">Características incluidas</h4>
                <ul class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Análisis financiero avanzado</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Modelos predictivos</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Evaluación de comportamiento</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Análisis de potencial</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Recomendaciones estratégicas</span>
                    </li>
                    <li class="flex items-start gap-2">
                        <i class="pi pi-check text-sym-success mt-0.5"></i>
                        <span class="text-sm text-sym-gray-700">Informe detallado</span>
                    </li>
                </ul>
            </div>

            <p-button label="Seleccionar y comenzar" icon="pi pi-arrow-right" iconPos="right"
                (onClick)="navigateToModel('oferta')" styleClass="w-full mt-auto" />
        </div>
    </div>

    <!-- Ayuda -->
    <p-message severity="info" [closable]="false" styleClass="w-full mt-8">
        <div class="flex items-start gap-3">
            <div>
                <h3 class="font-semibold mb-1">¿Necesitas ayuda para elegir?</h3>
                <p class="text-sm">
                    Para la mayoría de los casos recomendamos comenzar con "Nueva Oferta" que ofrece un análisis
                    más completo. Si solo deseas una evaluación rápida o tienes información limitada, "Oportunidad"
                    es la opción adecuada.
                </p>
            </div>
        </div>
    </p-message>
</div>
